import Vue from 'vue'
import FBSignInButton from 'vue-facebook-signin-button'

const vue_fb = {}
vue_fb.install = function install(Vue, options) {
  ; (function(d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[ 0 ]
    if (d.getElementById(id)) {
      return
    }
    js = d.createElement(s)
    js.id = id
    js.src = '//connect.facebook.net/en_US/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
  })(document, 'script', 'facebook-jssdk')

  window.fbAsyncInit = function onSDKInit() {
    if (window.FB) {
      window.FB.init(options)
      window.FB.AppEvents.logPageView()
    }
  }
}

Vue.use(vue_fb, {
  appId: process.env.VUE_APP_FACEBOOK,
  cookie: true,
  xfbml: true,
  version: 'v4.0'
})
Vue.use(FBSignInButton)
